import { createAction } from '@reduxjs/toolkit'
import { SET_CONNECTION } from './consts'

export const connectionActions = {
   setConnection: createAction(SET_CONNECTION, (payload) => ({ payload: { isConnected: payload } }))
}
